import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import HomePage from "../components/Home/HomePage";
import LandingPage from "../components/LandingPage/LandingPage";
import ProductPage from "../components/Product/ProductPage";
import StorePage from "../components/StorePicker/StorePage";
import CartPage from "../components/Cart/CartPage";
import CartStorePage from "../components/CartStore/CartStorePage";
import HelpPage from "../components/Help/HelpPage";
import NotFoundPage from "../components/NotFound/NotFoundPage";
import SummaryPage from "../components/Summary/SummaryPage";
import PriceComparisonSummary from "../components/PriceComparisonSummary/PriceComparisonSummaryPage";
import FavoriteProducts from "../components/User/FavoriteProducts";
import SavedCarts from "../components/User/SavedCarts";
import ResetPasswordRequest from "../components/ResetPasswordRequest/ResetPasswordRequest";
import ResetPasswordRequestForm from "../components/ResetPasswordRequestForm/ResetPasswordRequestForm";
//WhatInStock
import LocationPickerPage from "../components/WhatInStock/LocationPickerPage";
import ProductStatusPage from "../components/WhatInStock/ProductStatusPage";

//ProductMatchingTool
import PossibleExistingPage from "../components/ProductMatching/PossibleExistingMatchingGroupPage";
import PotentialMatchesPage from "../components/ProductMatching/PotentialMatchesPage";
import ProductMatchingGroupPage from "../components/ProductMatching/ProductMatchingGroupPage";
import ProductMatchingGroupListPage from "../components/ProductMatching/ProductMatchingGroupListPage";
import SimilarGroupsListPage from "../components/ProductMatching/SimilarGroupsListPage";
import CreateNewGroupPage from "../components/ProductMatching/CreateNewGroupPage";
// import SimReviewInOnePage from "../components/ProductMatching/Sim2Review/SimReviewInOnePage";
import PbsReviewInOnePage from "../components/ProductMatching/Sim2Review/PbsReviewInOnePage";
import RapidMatchingTool from "../components/ProductMatching/Sim2Review/RapidMatchingTool";
import CoopMatchesPage from "../components/ProductMatching/Sim2Review/CoopMatchesPage";
import GoldenTestResult from "../components/ProductMatching/Sim2Review/GoldenTestResult";
import StoreTestResult from "../components/ProductMatching/Sim2Review/StoreTestResult";

import MergeProductGroups from "../components/ProductMatching/Sim2Review/MergeProductGroups/index";
import MLResultReviewPage from "../components/ProductMatching/MLReview/MLResultReviewPage";
import CheckNotUp2DateProductsPage from "../components/ProductMatching/CheckNotUp2DateData/CheckNotUp2DateProductsPage";
import SummaryReportPage from "../components/ProductMatching/CheckNotUp2DateData/SummaryReportPage";
import ParserManagePage from "../components/ParserManage/ParserManagePage";
import LinkManagePage from "../components/AdminDashboard/LinkManagePage";
import ProductSimilarPage from "../components/ProductSimilar/ProductSimilarPage";

// import ScrollToTop from "react-router-scroll-top";
import LearnMorePage from "../components/WhatInStock/LearnMorePage";
import CompanyReportToolPage from "../components/CompanyReportTool/CompanyReportToolPage";
import CompanyReportToolProductPage from "../components/CompanyReportTool/CompanyReportToolProductPage";
import CompanyReportToolProductPageTree from "../components/CompanyReportTool/CompanyReportToolProductPageTree";
import CompanyReportToolCompetitorProductPage from "../components/CompanyReportTool/CompanyReportToolCompetitorProductPage";
import CompanyReportToolOutOfDatePage from "../components/CompanyReportTool/CompanyReportToolOutOfDatePage";
import PotentialMatches4ProjectPage from "../components/ProductMatching/PotentialMatches4ProjectPage";
import TagListPage from "../components/Tags/TagListPage";
import TagDetailPage from "../components/Tags/TagDetailPage";
import ProductStorePage from "../components/ProductStore/ProductStorePage";
import ProductStoreHistoryPricePage from "../components/ProductStore/ProductStoreHistoryPricePage";
import CompanyReportToolCheckedReportPage from "../components/CompanyReportTool/CompanyReportToolCheckedReportPage";
import CompanyReportToolStalePriceReportsPage from "../components/CompanyReportTool/CompanyReportToolStalePriceReportsPage";
import CompanyReportToolStalePriceReportsByPmgPage from "../components/CompanyReportTool/CompanyReportToolStalePriceReportsByPmgPage";
import CompanyReportToolStalePriceReportsByBannerPage from "../components/CompanyReportTool/CompanyReportToolStalePriceReportsByBannerPage";
import CompanyReportToolStalePriceReportsByCityPage from "../components/CompanyReportTool/CompanyReportToolStalePriceReportsByCityPage";
import CityStoresPage from "../components/City/CityStoresPage";
import CompanyReportToolOutOfDateStorePage from "../components/CompanyReportTool/CompanyReportToolOutOfDateStorePage";
// import VersionUpdate from "../components/Version/VersionUpdate"; //remove 
// import VersionUpdate from "../components/Version/VersionUpdate"; //remove 
// import SWVersionUpdate from "../components/Version/SWVersionUpdate"; //remove 



const loader = document.querySelector(".loader");
// const updateContainer = document.querySelector(".updateContainer");

// if you want to show the loader when React loads data again
const showLoader = () => loader.classList.remove("loader--hide");

const hideLoader = () => {
  loader.classList.add("loader--hide");
  // updateContainer.classList.add("loader--hide");
}

const AppRouter = () => {
  useEffect(hideLoader, []);
  
  return (
    <>
    {/* <SWVersionUpdate/> */}
    <BrowserRouter>
      {/* <ScrollToTop> */}
        <Switch>
          <Route path="/" component={LandingPage} exact={true} />
          <Route path="/home" component={HomePage} />
          <Route path="/stores" component={StorePage} />
          <Route path="/product/:id" component={ProductPage} />
          <Route path="/help" component={HelpPage} />
          
          <Route path="/pricecompare" component={SummaryPage} />
          <Route
            path="/pricecomparesummary"
            component={PriceComparisonSummary}
          />
          <Route path="/products/favorites" component={FavoriteProducts} />
          <Route path="/carts" component={SavedCarts} />
          <Route path="/cart" component={CartPage} />
          <Route path="/cartstore" component={CartStorePage} />
          <Route
            path="/resetpassword/request"
            component={ResetPasswordRequest}
            exact={true}
          />
          <Route
            path="/resetpassword/:token"
            component={ResetPasswordRequestForm}
          />
          {/* Covid-19 Help */}
          <Route path="/location-picker" component={LocationPickerPage} />
          <Route path="/product-status" component={ProductStatusPage} />
          <Route path="/learn-more" component={LearnMorePage} />
           {/* Admin Product Matching Tool  */}
          <Route path="/possible-existing/:id" component={PossibleExistingPage} />
          <Route path="/matching-potential/:id" component={PotentialMatchesPage} />
          <Route path="/matching-group/:id" component={ProductMatchingGroupPage} />
          <Route path="/matching-groups" component={ProductMatchingGroupListPage} />
          <Route path="/similar-groups" component={SimilarGroupsListPage} />
          <Route path="/create-new-group" component={CreateNewGroupPage} />
          {/* <Route path="/matching/sim/review" component={SimReviewInOnePage} /> */}
          <Route path="/matching/ml-review" component={MLResultReviewPage} />
          <Route path="/matching/pbs/review" component={PbsReviewInOnePage} />
          <Route path="/matching/rapid-matching-tool" component={RapidMatchingTool} />
          <Route path="/matching/merge-product-groups" component={MergeProductGroups} />
          <Route path="/matching/pbs/coop" component={CoopMatchesPage} />
          <Route path="/matching/golden-test" component={GoldenTestResult} />
          <Route path="/matching/store-test" component={StoreTestResult} />
          <Route path="/matching/check-not-up-to-date-products" component={CheckNotUp2DateProductsPage} />
          <Route path="/matching/ood-summary-report" component={SummaryReportPage} />
          <Route path="/parser-manage/dashboard" component={ParserManagePage} />
          <Route path="/dashboard" component={LinkManagePage} />
          <Route path="/matching/similar" component={ProductSimilarPage} />
          {/* Admin Company Report Tool for Analytic  */}
          <Route path="/company-report-tool" component={CompanyReportToolPage} />
          <Route path="/company-report-tool-product-tree/:id" component={CompanyReportToolProductPageTree} />
          <Route path="/company-report-tool-product/:id" component={CompanyReportToolProductPage} />
          <Route path="/company-report-tool-competitor-product/:id" component={CompanyReportToolCompetitorProductPage} />
          <Route path="/company-report-tool-out-of-date/:user_type_id/:project_id" component={CompanyReportToolOutOfDatePage} />
          <Route path="/company-report-tool-out-of-date-store/:user_type_id/:project_id" component={CompanyReportToolOutOfDateStorePage} />
         
          <Route path="/company-report-tool-checked-report/:user_type_id/:project_id" component={CompanyReportToolCheckedReportPage} />
          <Route path="/company-report-tool-stale-price-reports/:user_type_id/:project_id" component={CompanyReportToolStalePriceReportsPage} />
          <Route path="/company-report-tool-stale-price-reports-by-pmg/:user_type_id/:project_id" component={CompanyReportToolStalePriceReportsByPmgPage} />
          <Route path="/company-report-tool-stale-price-reports-by-banner/:user_type_id/:project_id" component={CompanyReportToolStalePriceReportsByBannerPage} />
          <Route path="/company-report-tool-stale-price-reports-by-city/:user_type_id/:project_id" component={CompanyReportToolStalePriceReportsByCityPage} />
          <Route path="/matching-potential-4project/:id/:projectid" component={PotentialMatches4ProjectPage} />
          <Route path="/tag/list" component={TagListPage} />
          <Route path="/tag/detail/:id/:name" component={TagDetailPage} />
          <Route path="/product-store/:product_id/:company_id" component={ProductStorePage} />
          <Route path="/product-store-history-prices/:product_id/:company_id/:store_id/:store_address" component={ProductStoreHistoryPricePage} />
          <Route path="/city/stores" component={CityStoresPage} />
          <Route component={NotFoundPage} />
        </Switch>
      {/* </ScrollToTop> */}
    </BrowserRouter>
    </>
  );
};

export default AppRouter;
